import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableAkitaProdMode, persistState } from '@datorama/akita';

import { environment } from 'environments/environment';

import { AppModule } from './app/app.module';

if (environment.production) {
	enableAkitaProdMode();
	enableProdMode();
}

const storage = persistState({
	include: ['ui-sidebar-coachees'],
	key: 'streeme-stores',
});
const providers = [{ provide: 'persistStorage', useValue: storage }];

platformBrowserDynamic(providers)
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));
